import { VatCategoryCode } from "../types";

export const ZM_VAT_CATEGORY_CODES = [
  VatCategoryCode.INCOME_EU_INTRA_B2B,
  VatCategoryCode.INCOME_EU_B2B,
] as const;
